/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Group_Auctions_Shares_PdfInputs */

const cs_sreality_group_auctions_shares_pdf = /** @type {(inputs: Sreality_Group_Auctions_Shares_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dražby / Podíly (PDF)`)
};

const en_sreality_group_auctions_shares_pdf = /** @type {(inputs: Sreality_Group_Auctions_Shares_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auctions / Shares (PDF)`)
};

/**
* | output |
* | --- |
* | "Auctions / Shares (PDF)" |
*
* @param {Sreality_Group_Auctions_Shares_PdfInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_group_auctions_shares_pdf = /** @type {((inputs?: Sreality_Group_Auctions_Shares_PdfInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Group_Auctions_Shares_PdfInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_group_auctions_shares_pdf(inputs)
	return cs_sreality_group_auctions_shares_pdf(inputs)
});